import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import useLiveQuery from "@/hooks/useLiveQuery";
import { dateLabel } from "@/components/OperationsUI";

export default function DriverOperationalNotice() {
  const { user } = useAuth();
  const live = useLiveQuery(`/operations/readiness/${user.id}`);
  if (!live.data?.suspensions.length) return null;
  return <div className="mb-4 rounded-xl border border-red-400 bg-red-950 p-4 text-sm text-red-100"><strong>Suspensão de carregamento pendente</strong><p className="mt-1">Procure seu supervisor antes do próximo carregamento. Fechamento(s): {live.data.suspensions.map(s => dateLabel(s.date)).join(", ")}.</p><Link className="mt-2 inline-block underline" to="/motorista/ocorrencias">Consultar minhas ocorrências</Link></div>;
}
